// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Z8TK","requiredAsterisk":"Info_requiredAsterisk__3X_Wu"};